import { Card, Col, List, Row } from "antd";
import React from "react";
import DashboardCard from "../DashboardCard";
import { useSelector } from "react-redux";
import { FcBusinessman, FcProcess } from "react-icons/fc";

const TImeSheetCards = () => {
  const { dashboardData: data } = useSelector((state) => state.dashboardState);


  console.log({ f: data?.timeSheetData?.highestPerformingStaff })
  return (
   <div>
     <Row gutter={4} className="mb-1">
        <Col span={12}>
          <DashboardCard
            title="TOTAL HOURS WORKED"
            value={`${data?.timeSheetData?.totalHoursWorked || 0} HR(S)`}
          />
        </Col>
        <Col span={12}>
          <DashboardCard
            title="HIGHEST PERFORMER"
            value={data.timeSheetData?.highestPerformingStaff?.staffName || "N/A"}
          />
        </Col>
    </Row>
    <Card title='PROJECT TIME SHEET HOURS'>
    <List
        pagination={{ position: 'bottom', align: 'center', pageSize: 4  }}
        dataSource={data?.timeSheetData?.groupedByProject || []}
        renderItem={(item, index) => (
          <List.Item key={index}>
            <List.Item.Meta
              avatar={<FcProcess />}
              title={item.project_name}
            />
            <div>
                {item?.totalHours || 0} HR(S)
            </div>
          </List.Item>
        )}
      />
    </Card>
    <Card title='STAFF TIME SHEET HOURS'>
    <List
        pagination={{ position: 'bottom', align: 'center', pageSize: 4  }}
        dataSource={data?.timeSheetData?.staffTimeSheetHours || []}
        renderItem={(item, index) => (
          <List.Item key={index}>
            <List.Item.Meta
              avatar={<FcBusinessman />}
              title={item.staffName}
            />
            <div>
                {item?.totalHoursWorked || 0} HR(S)
            </div>
          </List.Item>
        )}
      />
    </Card>
   </div>
  );
};

export default TImeSheetCards;
